import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
			<path d="M4 3.5h12v1H4zM0 3.5h2v1H0zM4 7.5h12v1H4zM0 7.5h2v1H0zM4 11.5h12v1H4zM0 11.5h2v1H0z" />
		</svg>
	);
};
